/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Listen when Add to Cart button is pressed on Sprie Widget
document.addEventListener('SprieEvent:onAssetCart', function (e) {
	// e.g. send async/ajax request to an endpoint to add to cart
	alert('Added to cart ' + e.detail.sku);
});

// Check if Camera permission was denied
document.addEventListener('SprieEvent:onCameraDenied', function (e) {
	alert('Camera Denied!');
});

// Check if Camera device is present or not.
document.addEventListener('SprieEvent:onCameraError', function (e) {
	alert('Camera Error : ' + e.detail.err);
});

document.addEventListener('DOMContentLoaded', function() {
    var carousel = document.querySelector('.ProductList.ProductList--carousel.Carousel');

    if (carousel) {
        carousel.addEventListener('touchstart', function() {
            carousel.style.animationPlayState = 'paused';
        });

        carousel.addEventListener('touchend', function() {
            carousel.style.animationPlayState = 'running';
        });
    }
});



document.querySelectorAll('[data-field-name="Initials"]').forEach(function (field) {
  field.addEventListener('input', function () {
    this.value = this.value.replace(/[^a-zA-Z]/g, '').toUpperCase();
  });
});